import {
  dataSearch,
  isMounted,
  pagingSearch,
} from '../../helpers/getter-commons';

// algos
export const getAlgos = (state) =>
  dataSearch(state.algos.list.data, {
    list: true,
  });
export const isAlgosFetching = (state) => state.algos.list.isFetching;
export const isAlgosMounted = (state) => isMounted(state.algos.list.data);
export const getAlgosPaging = (state) => pagingSearch(state.algos.list.data);

// algos by id
export const getAlgo = (state) => dataSearch(state.algos.selected.data);
export const isAlgoByIdFetching = (state) => state.algos.selected.isFetching;
export const isAlgoByIdMounted = (state) =>
  isMounted(state.algos.selected.data);
export const algoByIdError = (state) => state.algos.selected.errorMessage;

export const isAlgoConfigFetching = (state) => state.algos.config.isFetching;

const getConfigBase = (state) => dataSearch(state.algos.config.data);

export const getUnderlyingsExpiryTags = (state) =>
  getConfigBase(state).underlyingsExpiryTags
    ? getConfigBase(state).underlyingsExpiryTags
    : {};

export const getUnderlyingLotSizes = (state) =>
  getConfigBase(state).underlyingLotSizes
    ? getConfigBase(state).underlyingLotSizes
    : {};
